module.exports = __webpack_public_path__ + "static/media/DeskSpace.98bf2cc4.png";